<template>
  <article>
    <div class="StationWrapper">
      <div class="SvgAlign">
        <div class="Grid-Svg">
          <FindStationBG />
          <div class="ImageWrapper">
            <picture>
              <source
                type="image/webp"
                :srcset="
                  require('@/' +
                    `assets/homePage/iphone-map-${entity}-${lang}.webp`)
                "
              />
              <source
                type="image/png"
                :srcset="
                  require('@/' +
                    `assets/homePage/iphone-map-${entity}-${lang}.png`)
                "
              />

              <img
                alt="An iPhone with the Qwello App open and centered on a charging station icon"
                class="Image"
                :src="
                  require('@/' +
                    `assets/homePage/iphone-map-${entity}-${lang}.png`)
                "
              />
            </picture>
          </div>
        </div>
      </div>
      <div class="StationTextWrapper">
        <Title :v-style="{ maxWidth: '762px' }">{{
          $t('find_station.header')
        }}</Title>
        <Space :pheight="cardSpace" />
        <div class="flex Cards-Flat-Parent">
          <CardFlat
            svg="destinationsearch-ic.svg"
            :text="{ header: card1_header, text: card1_text }"
          />
          <CardFlat
            svg="availability-ic.svg"
            :text="{ header: card2_header, text: card2_text }"
          />
          <CardFlat
            svg="fav-ic.svg"
            :text="{ header: card3_header, text: card3_text }"
          />
        </div>
        <div class="Cards-Parent">
          <Card
            :svg="reservedOrPayment"
            :text="{ header: text1_header, text: text1_text }"
          />
          <Card
            svg="navigate-ic.svg"
            :text="{ header: text2_header, text: text2_text }"
          />
        </div>
      </div>
    </div>
    <section class="IpadView">
      <Card
        svg="reserved-pin.svg"
        :text="{ header: text1_header, text: text1_text }"
      />
      <Card
        svg="navigate-ic.svg"
        :text="{ header: text2_header, text: text2_text }"
      />
    </section>
    <Space :pheight="bottomSpace" />
  </article>
</template>
<script>
import { entity } from '@/../region.json';
import FindStationBG from '../icons/FindStationBG.vue';
import Card from './FindStations/Card.vue';
import Space from '../../layout/space';
import CardFlat from './FindStations/CardFlat.vue';
import Title from './Title.vue';
import i18n from '../../i18n';
import matchEntities from '../../shared/entityHelpers';

export default {
  data() {
    return {
      text1_header: i18n.t('find_station.bottom1.header'),
      text1_text: i18n.t('find_station.bottom1.text'),
      text2_header: i18n.t('find_station.bottom2.header'),
      text2_text: i18n.t('find_station.bottom2.text'),
      card1_header: i18n.t('find_station.card1.header'),
      card1_text: i18n.t('find_station.card1.text'),
      card2_header: i18n.t('find_station.card2.header'),
      card2_text: i18n.t('find_station.card2.text'),
      card3_header: i18n.t('find_station.card3.header'),
      card3_text: i18n.t('find_station.card3.text'),
      bottomSpace: null,
      cardSpace: null,
      lang: 'de',
      entity,
      reservedOrPayment: matchEntities(['POLAND', 'NETHERLANDS'])
        ? 'payment.svg'
        : 'reserved-pin.svg',
    };
  },
  components: {
    FindStationBG,
    Card,
    CardFlat,
    Space,
    Title,
  },
  created() {
    // init space width on mount
    this.separatorWidth();
    this.lang = i18n.locale;
  },
  methods: {
    separatorWidth() {
      if (window.innerWidth >= 1024 && this.cardSpace !== '100px') {
        this.bottomSpace = '150px';
        this.cardSpace = '100px';
      } else if (window.innerWidth < 1024 && this.cardSpace !== '0px') {
        this.bottomSpace = '60px';
        this.cardSpace = '40px';
      }
    },
    resize() {
      this.separatorWidth();
    },
  },
  mounted() {
    window.addEventListener('resize', this.resize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
  },
};
</script>
<style scoped>
article {
  --cards-width: 100%;
  --svg-align-width: 100%;
  --grid-svg-height: auto;
  --ipad-view-display: none;
  --grid-columns: minmax(auto, 330px) 1fr;
}

.StationWrapper {
  display: grid;
  grid-template-columns: 1fr;
}
.Image {
  max-width: 65%;
  height: auto;
  display: block;
  margin: 0 auto;
  justify-self: center;
}
.ImageWrapper {
  justify-self: center;
  /* max-width: 90%; */
  width: 100%;
  height: auto;
  display: block;
  justify-self: center;
}
.SvgAlign {
  width: var(--svg-align-width);
  max-height: var(--svg-height, none);
}
.Grid-Svg {
  display: grid;
  height: var(--grid-svg-height);
  align-items: center;
}

.Grid-Svg > * {
  grid-area: 1 / 1;
}
.StationTextWrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 2.5em;
  padding: 0 2.2em;
}
.TestSvg {
  align-self: center;
  justify-self: center;
  height: 60%;
  z-index: -10;
  transform: translateY(610px);
}
.FindSt-Title {
  font-size: 70px;
  max-width: 762px;
}
.Cards-Flat-Parent {
  display: grid;
  grid-template-columns: 1fr;
}
.Cards-Parent {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  margin-top: 2.5rem;
  width: var(--cards-width);
}
.IpadView {
  display: var(--ipad-view-display);
}

@media (min-width: 768px) {
  .Cards-Flat-Parent {
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  }
  .Cards-Parent {
    display: none;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: stretch;
  }
  .IpadView {
    margin-top: 32px;
    justify-content: space-around;
  }
  .StationWrapper {
    flex-direction: row;
    display: grid;
    grid-template-columns: var(--grid-columns);
  }
  .StationTextWrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 2.5em;
    padding: 0;
    margin-right: 40px;
  }
  .SvgAlign {
    margin-right: 2.5rem;
    max-width: 330px;
  }
  article {
    --cards-width: 85%;
    --svg-align-width: auto;
    --ipad-view-display: flex;
  }
}
@media (min-width: 860px) {
  .StationTextWrapper {
    margin-right: 0;
  }
}

@media (min-width: 1024px) {
  article {
    --ipad-view-display: none;
    --svg-align-width: 330px;
    --cards-width: 100%;
  }
  .Cards-Flat-Parent {
    grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  }
  .SvgAlign {
    flex: 0 0 auto;
    max-width: none;
  }
  .Cards-Parent {
    display: flex;
    justify-content: space-between;
  }
  .StationWrapper {
    padding-right: 60px;
  }
  .SvgAlign {
    margin-right: 1.5rem;
  }
}

@media (min-width: 1400px) {
  article {
    --cards-width: 95%;
    --grid-columns: minmax(auto, 35%) 65%;
    --svg-align-width: 80%;
  }
  .Cards-Parent {
    align-self: center;
  }
}

@media (min-width: 1600px) {
  article {
    --grid-svg-height: 100%;
    --svg-align-width: auto;
    --cards-width: 100%;
    --svg-height: 680px;
  }
  .SvgAlign {
    flex: 0 1 auto;
    margin-right: 4.5rem;
  }
  .Cards-Parent {
    justify-content: space-evenly;
  }
  .StationWrapper {
    padding-right: 6rem;
  }
}
</style>
